import axiosInstance from "@/lib/axios-instance";

type ContactRequest = {
  email: string;
  subject: string;
  description: string;
};

export const contactUs = async (request: ContactRequest) => {
  try {
    return await axiosInstance.post("contact", request);
  } catch (error: any) {
    console.error("Contact error:", error);
  }
};
